var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2697 0H0V39.63H31.5101V10.2404L21.2697 0ZM28.9997 10.0278H21.2697V2.39969L28.9997 10.0278ZM1.76811 38.0759V1.94265H20.029V10.8788C20.029 10.8788 20.029 11.2674 20.8061 11.2674H29.7422V38.0759H1.76811Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3032 32.6843H7.00867V34.0679H24.3032V32.6843Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3032 28.799H7.00867V30.1825H24.3032V28.799Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3852 11.0685H7.00854V12.452H17.3852V11.0685Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9292 16.3632H22.7631L17.6569 21.4692L14.2052 17.3257L6.57422 24.9573L7.3545 25.7713L14.2052 18.857L17.6569 23.0003L23.5287 17.1286V18.9601H24.8979V14.994H20.9292V16.3632Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3852 6.91785H7.00854V8.30141H17.3852V6.91785Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.a99b4934e2ac48fd3c45dd47506ac401.svg";
export { ForwardRef as ReactComponent };